/**
 * @fileoverview Page 404 brandée de la console backoffice.
 *
 * Rendue dans deux contextes :
 *   - route catch-all (`path: '*'`) enfant de `ConsoleLayout` — la sidebar
 *     et la topbar restent visibles, l'agent garde ses repères ;
 *   - `errorElement` racine du router — filet de sécurité si une erreur de
 *     rendu ou de navigation survient hors layout.
 *
 * Le composant reste autonome (aucune dépendance au layout) pour supporter
 * les deux contextes : un simple bloc centré autour d'un `<EmptyState>` du
 * design system, avec un retour explicite vers le Dashboard.
 */

import { Link } from 'react-router-dom';
import { Button, EmptyState } from '@gnpc/ui';
import { ArrowLeft, SearchX } from 'lucide-react';

export function NotFoundPage(): JSX.Element {
  return (
    // `min-h-[60vh]` : centre verticalement l'état vide dans les deux
    // contextes (dans le layout comme en pleine page) sans forcer un
    // `100vh` qui créerait un scroll parasite sous la topbar.
    <div className="grid min-h-[60vh] place-items-center">
      <EmptyState
        icon={<SearchX />}
        size="lg"
        // La 404 EST le contenu principal : son titre doit être le `<h1>`
        // de la page (axe `page-has-heading-one`).
        titleAs="h1"
        title="Page introuvable"
        description="L'adresse demandée n'existe pas ou n'est plus disponible. Vérifiez l'URL ou revenez au tableau de bord."
        action={
          <div className="flex flex-wrap items-center justify-center gap-2">
            <Button asChild>
              <Link to="/">
                <ArrowLeft className="size-4" />
                Retour au Dashboard
              </Link>
            </Button>
            {/* Voie de contact / support (C-38). */}
            <Button asChild variant="outline">
              <a href="mailto:support-gnpc@quipux.ci">Contacter le support</a>
            </Button>
          </div>
        }
      />
    </div>
  );
}
